import { render, staticRenderFns } from "./BiochemicalOxygen.vue?vue&type=template&id=670af050&scoped=true&"
import script from "./BiochemicalOxygen.vue?vue&type=script&lang=js&"
export * from "./BiochemicalOxygen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670af050",
  null
  
)

export default component.exports